var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Client from "./client";
import { log, Style } from "./helpers";
import { getLocal, LOCAL_STORAGE_KEYS, setLocal } from "./localStorageHelpers";
import utilitiesOutput from "../utility-data.json";
import { getFromSessionStorage, SESSION_STORAGE_KEYS } from "./sessionStorageHelpers";
var api = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token, api;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchToken()];
            case 1:
                token = _a.sent();
                api = Client;
                api.defaults.headers.common = {
                    Authorization: "Bearer " + token,
                };
                api.defaults.withCredentials = true;
                return [2 /*return*/, api];
        }
    });
}); };
var fetchToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getLocal("".concat(LOCAL_STORAGE_KEYS.JWT, "-").concat(window.widgetId));
                if (!token) return [3 /*break*/, 1];
                return [2 /*return*/, token];
            case 1: return [4 /*yield*/, getToken()
                    .then(function (_a) {
                    var data = _a.data;
                    return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            setLocal("".concat(LOCAL_STORAGE_KEYS.JWT, "-").concat(window.widgetId), data, 60 * 58);
                            return [2 /*return*/, data];
                        });
                    });
                })
                    .catch(function (err) {
                    var publicError = "";
                    if (err.response.status === 401) {
                        publicError = "Make sure you're using the correct Widget Id, or add the domain ".concat(window.widgetHost, " to your Widget Dashboard.");
                        log(publicError, Style.error);
                    }
                    publicError += " Widget could not be loaded using the current configuration: ".concat(err.response.data.errors.map(function (err) { return err.value; }));
                    log("Widget could not be loaded using the current configuration: ".concat(err.response.data.errors.map(function (err) { return err.value; })), Style.error);
                    window.self.history.pushState({ publicError: publicError }, "Oops!", "/oops");
                })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getToken = function (widgetId) {
    if (window.widgetHost && (widgetId || window.widgetId)) {
        return Client.get("Auth/token/".concat(widgetId ? widgetId : window.widgetId), {
            headers: {
                "X-Referer": window.widgetHost,
            },
        });
    }
    else {
        return Client.get("Auth/token/".concat(widgetId ? widgetId : window.widgetId)); //Get Token
    }
};
var replaceToken = function (widgetId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getToken(widgetId).then(function (_a) {
                    var data = _a.data;
                    return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            setLocal("".concat(LOCAL_STORAGE_KEYS.JWT, "-").concat(window.widgetId), data, 60 * 58);
                            return [2 /*return*/, data];
                        });
                    });
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getWidgetConfig = function (widgetId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Widgets/".concat(widgetId))];
        }
    });
}); };
var getEventData = function (eventNumber, typeCode, access, preview, groupId) { return __awaiter(void 0, void 0, void 0, function () {
    var typeCodeParam, accessParam, previewParam, groupIdParam, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                typeCodeParam = typeCode ? "typeCode=".concat(encodeURIComponent(typeCode)) : "";
                accessParam = access ? "access=".concat(encodeURIComponent(access)) : null;
                previewParam = preview ? "preview=".concat(preview) : null;
                groupIdParam = groupId ? "groupId=".concat(groupId) : null;
                params = [typeCodeParam, accessParam, previewParam, groupIdParam].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "?").concat(params))];
        }
    });
}); };
var getEventGroupsData = function (eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "/groups"))];
        }
    });
}); };
var getAttendeeTypes = function (eventNumber, typeCode, groupId) { return __awaiter(void 0, void 0, void 0, function () {
    var typeCodeParam, groupIdParam, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                typeCodeParam = typeCode ? "typeCode=".concat(encodeURIComponent(typeCode)) : null;
                groupIdParam = groupId ? "groupId=".concat(groupId) : null;
                params = [typeCodeParam, groupIdParam].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "/types?").concat(params))];
        }
    });
}); };
var postAttendeeTypes = function (cartId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var bfPayment, promo, allowExpire, paymentQuery, promoQuery, allowExpireQuery, originalOrderId, originalOrderIdQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bfPayment = getFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
                promo = getLocal(LOCAL_STORAGE_KEYS.PROMO);
                allowExpire = getLocal(LOCAL_STORAGE_KEYS.ALLOW_EXPIRE);
                paymentQuery = bfPayment ? "bfPayment=".concat(bfPayment) : null;
                promoQuery = promo ? "slipstream=".concat(promo) : null;
                allowExpireQuery = allowExpire === "true" ? "allowExpire=true" : null;
                originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(data.eventNumber));
                originalOrderIdQuery = originalOrderId ? "originalOrderId=".concat(originalOrderId) : null;
                params = [paymentQuery, promoQuery, originalOrderIdQuery, allowExpireQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Cart/".concat(cartId, "/attendees?").concat(params), data)];
        }
    });
}); };
var getTimeSlots = function (eventNumber, typeCode, groupId) { return __awaiter(void 0, void 0, void 0, function () {
    var typeCodeParam, groupIdParam, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                typeCodeParam = typeCode ? "typeCode=".concat(encodeURIComponent(typeCode)) : null;
                groupIdParam = groupId ? "groupId=".concat(groupId) : null;
                params = [typeCodeParam, groupIdParam].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "/timeslots?").concat(params))];
        }
    });
}); };
var deleteAttendee = function (cartId, attendeeId, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var bfPayment, paymentQuery, originalOrderId, originalOrderIdQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bfPayment = getFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
                paymentQuery = bfPayment ? "bfPayment=".concat(bfPayment) : null;
                originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(eventNumber));
                originalOrderIdQuery = originalOrderId ? "originalOrderId=".concat(originalOrderId) : null;
                params = [paymentQuery, originalOrderIdQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).delete("Cart/".concat(cartId, "/attendees/").concat(attendeeId, "?").concat(params))];
        }
    });
}); };
var getCart = function (cartId, promo, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var bfPayment, paymentQuery, excludePromos, excludeQuery, promoQuery, originalOrderId, originalOrderIdQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bfPayment = getFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
                paymentQuery = bfPayment ? "bfPayment=".concat(bfPayment) : null;
                excludePromos = getLocal(LOCAL_STORAGE_KEYS.REMOVED_PROMOS);
                excludeQuery = excludePromos ? "exclude=".concat(excludePromos) : null;
                promoQuery = promo ? "slipstream=".concat(promo) : null;
                originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(eventNumber));
                originalOrderIdQuery = originalOrderId ? "originalOrderId=".concat(originalOrderId) : null;
                params = [paymentQuery, promoQuery, originalOrderIdQuery, excludeQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Cart/".concat(cartId, "?").concat(params))];
        }
    });
}); };
var updateCart = function (cartId, payload, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var bfPayment, paymentQuery, originalOrderId, originalOrderIdQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bfPayment = getFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
                paymentQuery = bfPayment ? "bfPayment=".concat(bfPayment) : null;
                originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(eventNumber));
                originalOrderIdQuery = originalOrderId ? "originalOrderId=".concat(originalOrderId) : null;
                params = [paymentQuery, originalOrderIdQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Cart/".concat(cartId, "?").concat(params), payload)];
        }
    });
}); };
var clearCart = function (cartId, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var bfPayment, paymentQuery, originalOrderId, originalOrderIdQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bfPayment = getFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
                paymentQuery = bfPayment ? "bfPayment=".concat(bfPayment) : null;
                originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(eventNumber));
                originalOrderIdQuery = originalOrderId ? "originalOrderId=".concat(originalOrderId) : null;
                params = [paymentQuery, originalOrderIdQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).delete("Cart/".concat(cartId, "?").concat(params))];
        }
    });
}); };
var getQuestions = function (cartId, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var originalOrderId, originalOrderIdQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(eventNumber));
                originalOrderIdQuery = originalOrderId ? "originalOrderId=".concat(originalOrderId) : null;
                params = [originalOrderIdQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Cart/".concat(cartId, "/forms?").concat(params))];
        }
    });
}); };
var postBuyerQuestions = function (cartId, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Cart/".concat(cartId, "/form"), data)];
        }
    });
}); };
var postAttendeeQuestions = function (cartId, attendeeId, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Cart/".concat(cartId, "/attendees/").concat(attendeeId, "/form"), data)];
        }
    });
}); };
var getTimezones = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Utilities/Timezones")];
        }
    });
}); };
var getLocalization = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Utilities/LocalizationInfo")];
        }
    });
}); };
var getConstants = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Utilities/Constants")];
        }
    });
}); };
var getAllUtilities = function () {
    return utilitiesOutput;
};
var setCookie = function (key, value) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Utilities/cookie", { key: key, value: value })];
        }
    });
}); };
var postPromoCode = function (cartId, promoCode, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var bfPayment, paymentQuery, originalOrderId, originalOrderIdQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bfPayment = getFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
                paymentQuery = bfPayment ? "bfPayment=".concat(bfPayment) : null;
                originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(eventNumber));
                originalOrderIdQuery = originalOrderId ? "originalOrderId=".concat(originalOrderId) : null;
                params = [paymentQuery, originalOrderIdQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Cart/".concat(cartId, "/promotions?").concat(params), {
                    codeName: promoCode,
                })];
        }
    });
}); };
var removePromoCode = function (cartId, promoId, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var bfPayment, paymentQuery, originalOrderId, originalOrderIdQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bfPayment = getFromSessionStorage(SESSION_STORAGE_KEYS.BF_PAYMENT);
                paymentQuery = bfPayment ? "bfPayment=".concat(bfPayment) : null;
                originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(eventNumber));
                originalOrderIdQuery = originalOrderId ? "originalOrderId=".concat(originalOrderId) : null;
                params = [paymentQuery, originalOrderIdQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).delete("Cart/".concat(cartId, "/promotions/").concat(promoId, "?").concat(params))];
        }
    });
}); };
var postGroupForm = function (groupValues) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Groups", groupValues)];
        }
    });
}); };
var validateGroupPasscode = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Groups/validate", payload)];
        }
    });
}); };
var resendGroupPasscode = function (eventNumber, email, recaptchaResponse) { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    eventNumber: eventNumber,
                    email: email,
                    recaptchaResponse: recaptchaResponse,
                };
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Groups/forgot", payload)];
        }
    });
}); };
var postOrder = function (values) { return __awaiter(void 0, void 0, void 0, function () {
    var allowExpire, allowExpireQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (Object.keys(values.tokenInfo).length === 0) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    delete values.tokenInfo;
                }
                allowExpire = getLocal(LOCAL_STORAGE_KEYS.ALLOW_EXPIRE);
                allowExpireQuery = allowExpire === "true" ? "allowExpire=true" : null;
                params = [allowExpireQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Orders?".concat(params), values)];
        }
    });
}); };
var postOrderFree = function (values) { return __awaiter(void 0, void 0, void 0, function () {
    var allowExpire, allowExpireQuery, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                allowExpire = getLocal(LOCAL_STORAGE_KEYS.ALLOW_EXPIRE);
                allowExpireQuery = allowExpire === "true" ? "allowExpire=true" : null;
                params = [allowExpireQuery].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Orders/free?".concat(params), values)];
        }
    });
}); };
var getOrderResult = function (hash) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Orders/result/".concat(hash))];
        }
    });
}); };
var getEventList = function (clientKey, urlKey, search, startsAt, endsAt, category, eventNumber) {
    if (clientKey === void 0) { clientKey = null; }
    if (urlKey === void 0) { urlKey = null; }
    if (search === void 0) { search = null; }
    if (startsAt === void 0) { startsAt = null; }
    if (endsAt === void 0) { endsAt = null; }
    if (category === void 0) { category = null; }
    if (eventNumber === void 0) { eventNumber = null; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api()];
                case 1: return [2 /*return*/, (_a.sent()).get("Events?clientKey=".concat(clientKey).concat(urlKey ? "&urlKey=".concat(urlKey) : "").concat(search ? "&search=".concat(search) : "").concat(startsAt ? "&startsAt=".concat(startsAt) : "").concat(endsAt ? "&endsAt=".concat(endsAt) : "").concat(category ? "&category=".concat(category) : "").concat(eventNumber ? "&eventNumber=".concat(eventNumber) : ""))];
            }
        });
    });
};
var remoteValidate = function (eventNumber, fieldId, value, attendeeNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var attendeeNumberParam;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                attendeeNumberParam = attendeeNumber ? "&attendeeNumber=".concat(attendeeNumber) : "";
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "/fields/").concat(fieldId, "/remotevalidate?value=").concat(value).concat(attendeeNumberParam))];
        }
    });
}); };
var remoteFetch = function (eventNumber, fieldId, value, attendeeNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var attendeeNumberParam;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                attendeeNumberParam = attendeeNumber ? "&attendeeNumber=".concat(attendeeNumber) : "";
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "/fields/").concat(fieldId, "/remotefetch?value=").concat(value).concat(attendeeNumberParam))];
        }
    });
}); };
var postEmail = function (eventNumber, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Events/".concat(eventNumber, "/email"), data)];
        }
    });
}); };
var getSections = function (eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "/sections"))];
        }
    });
}); };
var getSection = function (eventNumber, sectionId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "/sections/").concat(sectionId))];
        }
    });
}); };
var getSeats = function (eventNumber, sectionId, quantity, accessKey, typeId, groupId, seatCode, nonconsecutive, basePrice) {
    if (sectionId === void 0) { sectionId = null; }
    if (quantity === void 0) { quantity = null; }
    if (accessKey === void 0) { accessKey = null; }
    if (typeId === void 0) { typeId = null; }
    if (groupId === void 0) { groupId = null; }
    if (seatCode === void 0) { seatCode = null; }
    if (nonconsecutive === void 0) { nonconsecutive = false; }
    if (basePrice === void 0) { basePrice = null; }
    return __awaiter(void 0, void 0, void 0, function () {
        var sectionIdParam, quantityParam, accessKeyParam, typeIdParam, groupIdParam, seatCodeParam, nonconsecutiveParam, basePriceParam, params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sectionIdParam = sectionId ? "sectionId=".concat(sectionId) : "";
                    quantityParam = quantity ? "quantity=".concat(quantity) : null;
                    accessKeyParam = accessKey ? "accessKey=".concat(encodeURIComponent(accessKey)) : null;
                    typeIdParam = typeId ? "typeId=".concat(typeId) : null;
                    groupIdParam = groupId ? "groupId=".concat(groupId) : null;
                    seatCodeParam = seatCode ? "seatCode=".concat(encodeURIComponent(seatCode)) : null;
                    nonconsecutiveParam = nonconsecutive ? "nonconsecutive=".concat(nonconsecutive) : null;
                    basePriceParam = basePrice ? "basePrice=".concat(basePrice) : null;
                    params = [
                        sectionIdParam,
                        quantityParam,
                        accessKeyParam,
                        typeIdParam,
                        groupIdParam,
                        seatCodeParam,
                        nonconsecutiveParam,
                        basePriceParam,
                    ]
                        .filter(function (x) { return x != null; })
                        .join("&");
                    return [4 /*yield*/, api()];
                case 1: return [2 /*return*/, (_a.sent()).get("Events/".concat(eventNumber, "/sections/").concat(sectionId, "/seats?").concat(params))];
            }
        });
    });
};
var postLookup = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Lookups", data)];
        }
    });
}); };
var getLookup = function (lookupId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Lookups/".concat(lookupId))];
        }
    });
}); };
var getEventLookup = function (lookupId, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Lookups/".concat(lookupId, "/events/").concat(eventNumber))];
        }
    });
}); };
var getMyAttendees = function (lookupId, eventNumber, includeGroups, includeOrders) { return __awaiter(void 0, void 0, void 0, function () {
    var includeGroupsParam, includeOrdersParam, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                includeGroupsParam = includeGroups ? "includeGroups=true" : null;
                includeOrdersParam = includeOrders ? "includeOrders=true" : null;
                params = [includeGroupsParam, includeOrdersParam].filter(function (x) { return x != null; }).join("&");
                return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Lookups/".concat(lookupId, "/events/").concat(eventNumber, "/attendees/?").concat(params))];
        }
    });
}); };
var getMyOrders = function (lookupId, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Lookups/".concat(lookupId, "/events/").concat(eventNumber, "/orders"))];
        }
    });
}); };
var getMyGroup = function (lookupId, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Lookups/".concat(lookupId, "/events/").concat(eventNumber, "/group"))];
        }
    });
}); };
var getAttendee = function (attendeeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Attendees/".concat(attendeeId))];
        }
    });
}); };
var getAttendeeForm = function (attendeeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Attendees/".concat(attendeeId, "/form"))];
        }
    });
}); };
var putAttendeeForm = function (attendeeId, attendeeForm) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/".concat(attendeeId, "/form"), attendeeForm)];
        }
    });
}); };
var postAttendeeForm = function (attendeeId, attendeeForm) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/".concat(attendeeId, "/form"), attendeeForm)];
        }
    });
}); };
var getAttendeePaymentInfo = function (attendeeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Attendees/".concat(attendeeId, "/payment"))];
        }
    });
}); };
var putAttendeePayment = function (attendeeId, paymentInput) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/".concat(attendeeId, "/payment"), paymentInput)];
        }
    });
}); };
var postAttendeePayment = function (attendeeId, attendeePaymentForm) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/".concat(attendeeId, "/payment"), attendeePaymentForm)];
        }
    });
}); };
var getAttendeeTypeInfo = function (attendeeId, typeCode) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Attendees/".concat(attendeeId, "/type").concat(typeCode ? "?typeCode=".concat(typeCode) : ""))];
        }
    });
}); };
var putAttendeeType = function (attendeeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/".concat(attendeeId, "/type"), payload)];
        }
    });
}); };
var postAttendeeType = function (attendeeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/".concat(attendeeId, "/type"), payload)];
        }
    });
}); };
var postAttendeeDonate = function (attendeeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/".concat(attendeeId, "/donate"))];
        }
    });
}); };
var postAttendeeDonateBulk = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/donate", payload)];
        }
    });
}); };
var postAttendeeShareBulk = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/share", payload)];
        }
    });
}); };
var putAttendeePaymentBulk = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/payment", payload)];
        }
    });
}); };
var postAttendeePaymentBulk = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/payment", payload)];
        }
    });
}); };
var putAttendeeGift = function (attendeeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/".concat(attendeeId, "/gift"), payload)];
        }
    });
}); };
var putAttendeeShare = function (attendeeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/".concat(attendeeId, "/share"), payload)];
        }
    });
}); };
var getAttendeeGroups = function (attendeeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Attendees/".concat(attendeeId, "/group"))];
        }
    });
}); };
var putAttendeeGroup = function (attendeeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/".concat(attendeeId, "/group"), payload)];
        }
    });
}); };
var getAttendeeCommunities = function (attendeeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Attendees/".concat(attendeeId, "/community"))];
        }
    });
}); };
var putAttendeeCommunity = function (attendeeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/".concat(attendeeId, "/community"), payload)];
        }
    });
}); };
var getOrder = function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Orders/".concat(orderId))];
        }
    });
}); };
var putOrder = function (orderId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Orders/".concat(orderId), payload)];
        }
    });
}); };
var getGroup = function (groupId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Groups/".concat(groupId))];
        }
    });
}); };
var putGroup = function (orderId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Groups/".concat(orderId), payload)];
        }
    });
}); };
var getProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Accounts/profile")];
        }
    });
}); };
var putProfile = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Accounts/profile", payload)];
        }
    });
}); };
var getGroupInEvent = function (groupId, eventNumber) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).get("Groups/".concat(groupId, "/in/").concat(eventNumber))];
        }
    });
}); };
var postGroupInEvent = function (groupId, eventNumber, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Groups/".concat(groupId, "/in/").concat(eventNumber), payload)];
        }
    });
}); };
var postEmailResend = function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Orders/".concat(orderId, "/resend"))];
        }
    });
}); };
var putOrderAssociate = function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Orders/".concat(orderId, "/associate"))];
        }
    });
}); };
var putOrderDisassociate = function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Orders/".concat(orderId, "/disassociate"))];
        }
    });
}); };
var postThirdPartData = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Utilities/thirdpartycustomers", payload)];
        }
    });
}); };
var postResendAttendeeSignatures = function (attendeeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/".concat(attendeeId, "/resendSignature"))];
        }
    });
}); };
var postResendOrderSignatures = function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Orders/".concat(orderId, "/resendSignature"))];
        }
    });
}); };
var postResendGroupSignatures = function (groupId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Groups/".concat(groupId, "/resendSignature"))];
        }
    });
}); };
// these currently only work for add-on attendees
var putCancelAttendee = function (attendeeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).put("Attendees/".concat(attendeeId, "/cancel"))];
        }
    });
}); };
var postCancelAttendee = function (attendeeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api()];
            case 1: return [2 /*return*/, (_a.sent()).post("Attendees/".concat(attendeeId, "/cancel"), payload)];
        }
    });
}); };
export { fetchToken, getToken, replaceToken, getWidgetConfig, getEventData, getEventGroupsData, getAttendeeTypes, postAttendeeTypes, getTimeSlots, getCart, updateCart, getQuestions, getTimezones, getLocalization, getConstants, getAllUtilities, clearCart, postBuyerQuestions, postAttendeeQuestions, deleteAttendee, remoteValidate, remoteFetch, postPromoCode, removePromoCode, getEventList, postGroupForm, validateGroupPasscode, resendGroupPasscode, setCookie, postEmail, postOrder, postOrderFree, getOrderResult, getSections, getSection, getSeats, postLookup, getLookup, getEventLookup, getMyAttendees, getMyOrders, getMyGroup, getAttendee, getAttendeeForm, putAttendeeForm, postAttendeeForm, getAttendeePaymentInfo, putAttendeePayment, postAttendeePayment, postAttendeeDonate, postAttendeeDonateBulk, postAttendeeShareBulk, putAttendeePaymentBulk, postAttendeePaymentBulk, getAttendeeTypeInfo, putAttendeeType, postAttendeeType, putAttendeeGift, putAttendeeShare, getAttendeeGroups, putAttendeeGroup, getAttendeeCommunities, putAttendeeCommunity, getOrder, putOrder, getGroup, putGroup, getProfile, putProfile, getGroupInEvent, postGroupInEvent, postEmailResend, putOrderAssociate, putOrderDisassociate, postThirdPartData, postResendAttendeeSignatures, postResendOrderSignatures, postResendGroupSignatures, putCancelAttendee, postCancelAttendee, };
